import renderMathInElement from 'auto-render';
export const useLatex = app => {
  app.directive('latex', {
    updated(el, binding) {
      el.innerHTML = binding.value;
      renderMathInElement(el, {});
    },
    mounted(el, binding) {
      el.innerHTML = binding.value;
      renderMathInElement(el, {});
    },
  });
};
